import { BaseModel, type RelationConfig } from './base';
import type { AlertCounts, AlertInstantiatedModelData, AlertAction } from '../types/interfaces/alert';

export class Alert extends BaseModel {
  idAlert!: number;
  alertType!: AlertType;
  primaryAction?: AlertAction;
  secondaryAction?: AlertAction;
  
  static override relations(): RelationConfig {
    return {
      primaryAction: { type: Object },
      secondaryAction: { type: Object },
    };
  }

  override objectID(): string {
    return this.idAlert?.toString() || '';
  }

  get category(): string {
    return 'secondary';
  }

  get icon(): string {
    return 'reservation';
  }
}

export enum AlertType {
  CustomerNewReservation = 1,
  CustomerCancelReservation = 2,
  CustomerCheckin = 3,
  CustomerOnlinePayment = 4,
  SmsLow = 6,
  SubscriptionPaymentSuccess = 7,
  SubscriptionPaymentFailed = 8,
}

export const AlertTypeLabels: Record<AlertType, string> = {
  [AlertType.CustomerNewReservation]: 'alert.customerNewReservation',
  [AlertType.CustomerCancelReservation]: 'alert.customerCancelReservation',
  [AlertType.CustomerCheckin]: 'alert.customerCheckin',
  [AlertType.CustomerOnlinePayment]: 'alert.customerOnlinePayment',
  [AlertType.SmsLow]: 'alert.smsLow',
  [AlertType.SubscriptionPaymentSuccess]: 'alert.subscriptionPaymentSuccess',
  [AlertType.SubscriptionPaymentFailed]: 'alert.subscriptionPaymentFailed',
}; 